import { render, staticRenderFns } from "./PvrSummaryByMakePod.vue?vue&type=template&id=1c89dd12&scoped=true"
import script from "./PvrSummaryByMakePod.vue?vue&type=script&lang=js"
export * from "./PvrSummaryByMakePod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c89dd12",
  null
  
)

export default component.exports